const urlBackEnd={
    authUrl: "https://full-rest-api.onrender.com/auth/login",
    servUrl: "https://full-rest-api.onrender.com/service",
    contacUrl: "https://full-rest-api.onrender.com/contac/sendContacts",
    localUrl:"http://localhost:3000/service"
}

export default urlBackEnd;